import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCaseContext } from '../context/CaseContext';
import '../mobile.css';

const MobileStatements = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { fullFIR } = useCaseContext();
  const fir = location.state?.fir || fullFIR;
  const responses = location.state?.responses || fir?.investigation?.responses || [];

  if (!fir) return <p style={{ textAlign: 'center', fontWeight: 700 }}>No case data available.</p>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
        <button className="m-button-primary" style={{ width: 'auto', padding: '8px 14px' }} onClick={() => navigate('/m/fir/statements/new', { state: { id: fir.id } })}>
          Add Statement
        </button>
      </div>

      {responses.length === 0 && <p style={{ textAlign: 'center', fontWeight: 700 }}>No statements recorded yet.</p>}

      {responses.map((item, index) => (
        <div key={index} className="m-card">
          <div style={{ fontSize: '16px', fontWeight: 700, color: '#111' }}>{item.respondent}</div>
          <div style={{ marginTop: '4px', textAlign: 'justify' }}>
            {item.ofWitness === 'Yes' ? 'Witness' : 'Respondent'}{item.age ? `, Age ${item.age}` : ''}{item.gender ? `, ${item.gender}` : ''}
          </div>
          {item.ofWitness === 'Yes' && item.ofEyewitness && <div style={{ marginTop: '4px', textAlign: 'justify' }}>Eyewitness: {item.ofEyewitness}</div>}
          <div style={{ marginTop: '4px', color: item.inconsistentWithFIR === 'Yes' ? '#E53935' : '#4CAF50', textAlign: 'justify' }}>
            Inconsistent with FIR: {item.inconsistentWithFIR || 'No'}
          </div>

          <div style={{ display: 'flex', gap: '12px', marginTop: '10px' }}>
            <button
              className="m-button-primary"
              style={{ width: 'auto', padding: '8px 14px', fontSize: '13px' }}
              onClick={() => navigate('/m/fir/statements/view', { state: { statement: item } })}
            >
              View
            </button>
            <button
              className="m-button-primary"
              style={{ width: 'auto', padding: '8px 14px', fontSize: '13px', background: '#509acb' }}
              onClick={() => navigate('/m/fir/statements/dashboard', { state: { statement: item } })}
            >
              Analyze
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MobileStatements;
